import React, { useRef, useState, useEffect } from 'react'
import { formatDateStandard } from '../../../../global/formatters/string-formatter'

export default function ETFCapitalGainsDistributions(props) {
  const SHOW_5_NO_SCROLL = 0
  const SHOW_ALL_NO_SCROLL = 1
  const SHOW_5_SCROLL = 2

  const { distributions } = props
  const [showAllDistributions, setShowAllDistributions] =
    useState(SHOW_5_NO_SCROLL)

  const distributionsTop = useRef(null)

  useEffect(() => {
    if (showAllDistributions === SHOW_5_SCROLL) {
      const element = distributionsTop.current

      const top = element ? defineSectionTop(element) : 0

      window.scrollTo({
        left: 0,
        top: top,
        behavior: 'smooth',
      })
    }
  }, [showAllDistributions])

  const defineSectionTop = (ref) => {
    const rect = ref.getBoundingClientRect()
    const headerHeight = 600
    const jumpScrollInitialLimit = 195

    const formula =
      window.pageYOffset +
      (rect.top + (window.pageYOffset > jumpScrollInitialLimit ? 300 : 160)) -
      headerHeight

    return formula
  }

  const toggleDistributions = () => {
    setShowAllDistributions(
      showAllDistributions == SHOW_5_NO_SCROLL
        ? SHOW_ALL_NO_SCROLL
        : showAllDistributions == SHOW_ALL_NO_SCROLL
          ? SHOW_5_SCROLL
          : SHOW_ALL_NO_SCROLL
    )
  }

  return (
    <div
      className="Content u-borderColorNeutralLight u-borderBottom u-borderTop0 u-borderLeft0 u-borderRight0 u-marginBottom6gu u-paddingBottom6gu u-paddingTop0"
      id="etf-distributions"
      ref={distributionsTop}
    >
      <h3 className="u-marginTop3gu">Distributions</h3>
      <div className="u-overflowX u-marginBottom4gu">
        <table
          className="Table Table--reversed Table--striped"
          id="etf-distributions-table"
        >
          <thead className="Table-head">
            <tr className="Table-row">
              <th className="Table-header" colSpan="2"></th>
              <th
                className="Table-header Table-header--bracketed u-textCenter"
                colSpan="6"
              >
                Breakdown of Distribution
              </th>
            </tr>
            <tr className="Table-row">
              <th className="Table-header u-textRight">Ex-Date</th>
              <th className="Table-header u-textRight">Record Date</th>
              <th className="Table-header u-textRight">Payable Date</th>
              <th className="Table-header u-textRight">Income</th>
              <th className="Table-header u-textRight">
                Short-term Capital Gains
              </th>
              <th className="Table-header u-textRight">
                Long-term Capital Gains
              </th>
              <th className="Table-header u-textRight">Return of Capital</th>
              <th className="Table-header u-textRight">Total Distribution</th>
            </tr>
          </thead>
          <tbody className="Table-body">
            {distributions &&
              distributions.length > 0 &&
              distributions.map((dist, index) => {
                const tableRow = (
                  <tr className="Table-row" key={dist.declarationDt + index}>
                    <td className="Table-cell u-textRight">
                      {formatDateStandard(dist.declarationDt)}
                    </td>
                    <td className="Table-cell u-textRight">
                      {formatDateStandard(dist.recordDt)}
                    </td>
                    <td className="Table-cell u-textRight">
                      {formatDateStandard(dist.payDt)}
                    </td>
                    <td className="Table-cell u-textRight">${dist.cashAmt}</td>
                    <td className="Table-cell u-textRight">
                      {dist.shortTermCapitalGainAmt
                        ? dist.shortTermCapitalGainAmt
                        : '-'}
                    </td>
                    <td className="Table-cell u-textRight">
                      {dist.longTermCapitalGainAmt
                        ? dist.longTermCapitalGainAmt
                        : '-'}
                    </td>
                    <td className="Table-cell u-textRight">
                      {dist.longTermCapitalGainAmt
                        ? dist.returnOfCapitalAmt
                        : '-'}
                    </td>
                    <td className="Table-cell u-textRight">
                      $
                      {dist.totalDistributionAmt
                        ? dist.totalDistributionAmt
                        : '-'}
                    </td>
                  </tr>
                )

                if (showAllDistributions == SHOW_ALL_NO_SCROLL) {
                  return tableRow
                } else if (index <= 4) {
                  return tableRow
                }
              })}
          </tbody>
        </table>
        {/* Should this a tag be a button? */}
        {distributions && distributions.length > 5 && (
          <button
            id="view-all-etf-distributions"
            className="Button Button--secondary u-marginTop6gu u-textNoTransform u-marginHoriz2gu u-marginBottom1gu"
            onClick={toggleDistributions}
          >
            {showAllDistributions != SHOW_ALL_NO_SCROLL
              ? 'Show all distributions'
              : 'Show last 5 distributions'}
          </button>
        )}
      </div>
    </div>
  )
}
